// @ts-nocheck
import {
  HeadingIcon,
  InstructionIcon,
  FullNameIcon,
  EmailIcon,
  AddressIcon,
  PhoneIcon,
  ShortTextIcon,
  FileUploadIcon,
  DateIcon,
  YesNoNaIcon,
  MultipleChoiceIcon,
  CheckBoxIcon,
  RadioGroupIcon,
  DropdownIcon,
  ImageUploadIcon,
  SignatureIcon,
  TimeIcon,
  NumberIcon,
  AdvancedTableIcon,
  SimpleTableIcon,
} from './constantSvg';
import deepCopy from 'utils/cloneObj';

export const generateUniqueId = () => {
  const id = crypto.randomUUID();
  return `item-${id}`;
};

export const FIELD_TYPES = {
  SECTION: 'section',
  INSTRUCTION: 'instruction',
  TEXT: 'text',
  EMAIL: 'email',
  PHONE: 'phone',
  NUMBER: 'number',
  DATE: 'date',
  TIME: 'time',
  DATETIMELLOCAL: 'datetimelocal',
  YESNO: 'yesno',
  YESNONA: 'yesnona',
  RADIOGROUP: 'radiogroup',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  MULTIPLESELECT: 'multipleselect',
  TABLE: 'table',
  PREDEFINEDTABLE: 'advtable',
  FILES: 'files',
  IMAGES: 'images',
  SIGNATURE: 'signature',
  MULTISIGNATURE: 'multisignature',
};

export const initialAnswers = {
  fullname: '',
  email: '',
  address: '',
  phone: '',
  number: '',
  shorttext: '',
  longtext: '',
  date: '',
  time: '',
  datetimelocal: '',
  yesno: '',
  yesnona: '',
  radiogroup: '',
  checkbox: '',
  dropdown: '',
  multipleselect: '',
  files: [],
  images: [],
  signature: {},
  multisignature: [],
};

export const formFields = {
  section: {
    type: FIELD_TYPES.SECTION,
    name: 'Section Heading',
    label: '',
    instruction: '',
    icon: HeadingIcon,
  },
  instruction: {
    type: FIELD_TYPES.INSTRUCTION,
    name: 'Instruction',
    label: '',
    instruction: '',
    attachments: [],
    icon: InstructionIcon,
  },
  fullname: {
    type: FIELD_TYPES.TEXT,
    name: 'Full Name',
    label: '',
    isRequired: false,
    answer: '',
    icon: FullNameIcon,
  },
  email: {
    type: FIELD_TYPES.EMAIL,
    name: 'Email',
    label: '',
    isRequired: false,
    answer: '',
    icon: EmailIcon,
  },
  address: {
    type: FIELD_TYPES.TEXT,
    name: 'Address',
    label: '',
    isRequired: false,
    answer: '',
    icon: AddressIcon,
  },

  phone: {
    type: FIELD_TYPES.PHONE,
    name: 'Phone Number',
    label: '',
    isRequired: false,
    answer: '',
    icon: PhoneIcon,
  },

  number: {
    type: FIELD_TYPES.NUMBER,
    name: 'Number Input',
    label: '',
    isRequired: false,
    answer: '',
    icon: NumberIcon,
  },

  shorttext: {
    type: FIELD_TYPES.TEXT,
    name: 'Short Text',
    label: '',
    isRequired: false,
    icon: ShortTextIcon,
    answer: '',
  },
  longtext: {
    type: FIELD_TYPES.TEXT,
    name: 'Long Text',
    label: '',
    isRequired: false,
    icon: HeadingIcon,
    answer: '',
  },

  date: {
    type: FIELD_TYPES.DATE,
    name: 'Date',
    label: '',
    isRequired: false,
    icon: DateIcon,
    answer: '',
  },
  time: {
    type: FIELD_TYPES.TIME,
    name: 'Time',
    label: '',
    isRequired: false,
    icon: TimeIcon,
    answer: '',
  },
  datetimelocal: {
    type: FIELD_TYPES.DATETIMELLOCAL,
    name: 'Date Time',
    label: '',
    isRequired: false,
    icon: DateIcon,
    answer: '',
  },

  yesno: {
    type: FIELD_TYPES.YESNO,
    name: 'Yes/No',
    label: '',
    isConditional: false,
    fromManualList: true,
    isRequired: false,
    actionMessage: '',
    answer: '',
    choice: [
      {
        label: 'Yes',
        action: false,
        notify_To: [],
      },
      {
        label: 'No',
        action: false,
        notify_To: [],
      },
    ],

    icon: YesNoNaIcon,
  },
  yesnona: {
    type: FIELD_TYPES.YESNONA,
    name: 'Yes/No/NA',
    label: '',
    isConditional: false,
    fromManualList: true,
    isRequired: false,
    actionMessage: '',
    answer: '',
    choice: [
      {
        label: 'Yes',
        action: false,
        notify_To: [],
      },
      {
        label: 'No',
        action: false,
        notify_To: [],
      },
      {
        label: 'NA',
        action: false,
        notify_To: [],
      },
    ],

    icon: YesNoNaIcon,
  },

  radiogroup: {
    type: FIELD_TYPES.RADIOGROUP,
    name: 'Radio',
    label: '',
    isRequired: false,
    isConditional: false,
    fromManualList: true,
    icon: RadioGroupIcon,
    choice: [
      {
        label: '',
        type: 'option',
        isOtherField: false,
        action: false,
        notify_To: [],
        image: null,
      },
    ],
    answer: '',
    actionMessage: '',
  },
  checkbox: {
    type: FIELD_TYPES.CHECKBOX,
    name: 'Checkboxes',
    label: '',
    isRequired: false,
    isConditional: false,
    fromManualList: true,
    icon: CheckBoxIcon,
    choice: [
      {
        label: '',
        type: 'option',
        isOtherField: false,
        action: false,
        notify_To: [],
        image: null,
      },
    ],
    answer: '',
    actionMessage: '',
  },
  dropdown: {
    type: FIELD_TYPES.DROPDOWN,
    name: 'Single Select Dropdown',
    label: '',
    isRequired: false,
    isConditional: false,
    icon: DropdownIcon,
    choice: [
      {
        value: '',
        label: '',
        type: 'option',
        isOtherField: false,
        action: false,
        notify_To: [],
      },
    ],
    fromManualList: true,
    islinked_query: '',
    answer: '',
    actionMessage: '',
    selectedLinkListLabel: '',
    association: true,
  },
  multipleselect: {
    type: FIELD_TYPES.MULTIPLESELECT,
    name: 'Multi-Select Dropdown',
    label: '',
    isRequired: false,
    isConditional: false,
    choice: [
      {
        value: '',
        label: '',
        type: 'option',
        isOtherField: false,
        action: false,
        notify_To: [],
      },
    ],
    fromManualList: true,
    islinked_query: '',
    answer: '',
    icon: MultipleChoiceIcon,
    actionMessage: '',
    selectedLinkListLabel: '',
    association: true,
  },

  table: {
    type: FIELD_TYPES.TABLE,
    name: 'Dynamic Table',
    isRow: true,
    isRequired: false,
    maxRows: '',
    label: '',
    headers: ['Column 1', 'Column 2', 'Column 3'],
    contents: [
      [
        {
          type: FIELD_TYPES.TEXT,
          name: 'Short Text',
          label: '',
          isRequired: false,
          answer: '',
        },
        {
          type: FIELD_TYPES.TEXT,
          name: 'Short Text',
          label: '',
          isRequired: false,
          answer: '',
        },
        {
          type: FIELD_TYPES.TEXT,
          name: 'Short Text',
          label: '',
          isRequired: false,
          answer: '',
        },
      ],
    ],
    icon: SimpleTableIcon,
  },
  // The 'advtable' identifier originally referred to an "Advanced Table".
  // It has since been renamed to "Predefined Table" to better reflect its purpose and usage.
  advtable: {
    type: FIELD_TYPES.PREDEFINEDTABLE,
    name: 'Predefined Table',
    isRow: true,
    isRequired: false,
    label: '',
    headers: ['Column 1', 'Column 2', 'Column 3'],
    contents: [
      [
        {
          type: FIELD_TYPES.TEXT,
          name: 'Short Text',
          label: '',
          isRequired: false,
          answer: '',
        },
        {
          type: FIELD_TYPES.TEXT,
          name: 'Short Text',
          label: '',
          isRequired: false,
          answer: '',
        },
        {
          type: FIELD_TYPES.TEXT,
          name: 'Short Text',
          label: '',
          isRequired: false,
          answer: '',
        },
      ],
    ],
    icon: AdvancedTableIcon,
  },

  files: {
    type: FIELD_TYPES.FILES,
    name: 'File Upload',
    label: '',
    isRequired: false,
    isMultiple: true,
    answer: [],
    icon: FileUploadIcon,
  },
  images: {
    type: FIELD_TYPES.IMAGES,
    name: 'Image Upload',
    label: '',
    isRequired: false,
    isMultiple: true,
    answer: [],
    icon: ImageUploadIcon,
  },

  signature: {
    type: FIELD_TYPES.SIGNATURE,
    name: 'Signature',
    label: '',
    isRequired: false,
    icon: SignatureIcon,
    answer: {},
  },
  multisignature: {
    type: FIELD_TYPES.MULTISIGNATURE,
    name: 'Multiple Signature',
    label: '',
    isRequired: false,
    icon: SignatureIcon,
    answer: [],
  },
};

export const createField = (fieldType) => {
  if (!formFields[fieldType]) {
    throw new Error(`Field type "${fieldType}" does not exist.`);
  }

  const { ...fieldTemplate } = deepCopy(formFields[fieldType]);

  const field = {
    ...fieldTemplate,
    id: generateUniqueId(),
  };

  if (field.choice) {
    field.choice = field.choice.map((choice) => ({
      ...choice,
      id: generateUniqueId(),
    }));
  }

  if (field.contents) {
    field.contents = field.contents.map((row) =>
      row.map((cell) => ({
        ...cell,
        id: generateUniqueId(),
      })),
    );
  }

  return field;
};

export const getTextType = (name: string) => {
  switch (name) {
    case 'Short Text':
      return 'shorttext';
    case 'Long Text':
      return 'longtext';
    case 'Address':
      return 'address';
    case 'Full Name':
      return 'fullname';
  }
};

export const INITIAL_ITEMS = [
  {
    title: 'Forms',
    description: 'Dynamic form generator',
    elements: [
      {
        labels: 'Table',
      },
      formFields.table,
      formFields.advtable,

      {
        labels: 'General',
      },
      formFields.section,
      formFields.instruction,
      formFields.fullname,
      formFields.email,
      formFields.address,
      formFields.phone,

      {
        labels: 'Text',
      },

      formFields.number,
      formFields.shorttext,
      formFields.longtext,

      {
        labels: 'Date',
      },
      formFields.date,
      formFields.time,
      formFields.datetimelocal,

      {
        labels: 'Yes/No',
      },
      formFields.yesno,
      formFields.yesnona,

      {
        labels: 'List',
      },
      formFields.radiogroup,
      formFields.checkbox,
      formFields.dropdown,
      formFields.multipleselect,

      {
        labels: 'Attachments',
      },

      formFields.files,
      formFields.images,

      {
        labels: 'Signature',
      },
      formFields.signature,
      formFields.multisignature,
    ],
    setting: {
      assign_to_project: {
        project: [],
        assign_to_all: false,
        timesheet_required: false,
        timesheet_clockin_compulsory: false,
      },
      assign_to_user: {
        assign_to_all: false,
        user_roles: [],
        users: [],
      },
      assign_to_employee: {
        assign_to_all: false,
        employee_roles: [],
        employees: [],
        timesheet_required: false,
        timesheet_clockin_compulsory: false,
      },

      assign_to_equipment: {
        equipment_type: [],
        equipment: [],
        timesheet_clockin_compulsory: false,
      },
      tags: [],
      notify_on_response: [],
      status_on_submission: '',
      collect_geolocation: false,
      edit_responses: false,
    },
  },
];
// ###############################################################

export const formats = ['bold', 'italic', 'underline', 'list', 'align'];

export const modules = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
      ],
    ],
  },
};

export const LINK_TO_LIST_OPTION = [
  { id: 'project', label: 'Project' },
  { id: 'equipment', label: 'Equipment' },
  { id: 'employee', label: 'Employee' },
  { id: 'supplier', label: 'Supplier' },
  { id: 'user', label: 'User' },
  { id: 'client', label: 'Client' },
];
export const FREQUENCY_OPTIONS = [
  { id: 'Anytime', label: 'Anytime' },
  { id: 'One Time', label: 'One Time' },
  { id: 'Daily', label: 'Daily' },
  { id: 'Weekly', label: 'Weekly' },
  { id: 'Monthly', label: 'Monthly' },
  { id: 'Yearly', label: 'Yearly' },
];
export const WEEK_START_OPTIONS = [
  { id: 'Monday', label: 'Monday' },
  { id: 'Tuesday', label: 'Tuesday' },
  { id: 'Wednesday', label: 'Wednesday' },
  { id: 'Thursday', label: 'Thursday' },
  { id: 'Friday', label: 'Friday' },
  { id: 'Saturday', label: 'Saturday' },
  { id: 'Sunday', label: 'Sunday' },
];
export const WEEKLY_FREQUENCY_OPTION = 'Weekly';
